// extracted by mini-css-extract-plugin
module.exports = {"locationList":"location-list_locationList__3mjmu"};